import { stripMarkdown } from '@littlebird/markdown-utils';
import { selectReasoningDisplayEntries } from '@littlebird/ui-utils';

import {
  getStepDisplayLabelParts,
  getStepDisplayMetadata,
  getStepTitle,
  ReasoningStatus,
} from '@/components/blocks/Message/reasoning';

import type {
  TurnActivityChildItem,
  TurnActivityEntry,
} from './chatItems.types';

const MAX_LABEL_LENGTH = 90;

const toSingleLine = (content: string): string => {
  const plain = stripMarkdown(content).trim();
  const firstLine = plain.split('\n').find((line) => line.trim().length > 0);
  const label = (firstLine ?? plain).trim();
  return label.length > MAX_LABEL_LENGTH
    ? `${label.slice(0, MAX_LABEL_LENGTH).trimEnd()}…`
    : label;
};

export const buildTurnActivityEntries = (
  items: TurnActivityChildItem[]
): TurnActivityEntry[] => {
  const entries: TurnActivityEntry[] = [];

  for (const item of items) {
    if (item.type === 'assistantResponse') {
      const label = toSingleLine(item.message.content ?? '');
      if (label) entries.push({ id: item.message.id, label });
      continue;
    }

    const isPending = item.status === ReasoningStatus.Pending;
    const displayEntries = selectReasoningDisplayEntries(
      item.steps,
      item.status,
      getStepDisplayMetadata
    );
    displayEntries.forEach(({ step }, index) => {
      const isActive = isPending && index === displayEntries.length - 1;
      const label =
        getStepDisplayLabelParts(step)?.join(' · ') ??
        getStepTitle(step, isActive);
      if (label) entries.push({ id: step.id, label, step });
    });
  }

  return entries;
};
